module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_FR-e7be711a4693b86fea295d09cb8b5fb1.svg";